import React from "react";
import {
  View,
  Text,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Image,
} from "react-native";
import { AppColors } from "../../../../../utility/AppColors";
import { AppImages } from "../../../../../utility/AppImages";
import { AppFontStyle } from "../../../../../styles/AppFontStyle";

interface StopStreamModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const StopStreamModal: React.FC<StopStreamModalProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      transparent
      visible={visible}
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          {/* Header */}
          <View style={styles.header}>
            <Text style={styles.title}>stop streaming</Text>
            <TouchableOpacity onPress={onClose}>
              <Image
                source={AppImages.icCloseWhite}
                style={[styles.closeIcon, { tintColor: "#DC2626" }]}
              />
            </TouchableOpacity>
          </View>

          {/* Content */}
          <View style={styles.content}>
            <View style={styles.iconContainer}>
              <Image
                source={AppImages.Stop_Stream}
                style={[styles.stopIcon, { tintColor: "#DC2626" }]}
                resizeMode="contain"
              />
            </View>
            <Text style={styles.message}>Are you sure you want to stop?</Text>
          </View>

          {/* Footer / Buttons */}
          <View style={styles.footer}>
            <TouchableOpacity style={styles.cancelButton} onPress={onClose}>
              <Text style={styles.cancelButtonText}>No</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.confirmButton} onPress={onConfirm}>
              <Text style={styles.confirmButtonText}>Yes</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: "90%",
    maxWidth: 400,
    backgroundColor: "#121212", // Requested BG color
    borderRadius: 16,
    padding: 24,
    borderWidth: 1,
    borderColor: "#333",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    color: "white",
    fontFamily: "Anybody-Bold",
  },
  closeIcon: {
    width: 24,
    height: 24,
    tintColor: "#9CA3AF",
  },
  content: {
    alignItems: "center",
    marginBottom: 32,
  },
  iconContainer: {
    marginBottom: 24,
  },
  stopIcon: {
    width: 64,
    height: 64,
    // tintColor set inline
  },
  message: {
    fontSize: 16,
    color: "#D1D5DB",
    textAlign: "center",
    fontFamily: "Anybody-Regular",
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 16,
  },
  cancelButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#FFF", // White border like EventTypeScreen Back button
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  cancelButtonText: {
    color: "white",
    fontSize: 14,
    fontFamily: "Anybody-Bold",
  },
  confirmButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    backgroundColor: "#DC2626", // Red color like EventTypeScreen Next button
    alignItems: "center",
    justifyContent: "center",
  },
  confirmButtonText: {
    color: "white",
    fontSize: 14,
    fontFamily: "Anybody-Bold",
  },
});

export default StopStreamModal;
